import { DatePipe } from '@angular/common'
import { Component, inject, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ReleaseNotesService } from 'src/app/core/services/release-notes/release-notes.service'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { ReleaseNote } from 'src/app/shared/interfaces/release-notes/release-note.interface'

@Component({
    selector: 'sf-latest-release-note-dialog',
    imports: [
        ButtonComponent,
        DatePipe
    ],
    templateUrl: './latest-release-note-dialog.component.html',
    styleUrls: ['./latest-release-note-dialog.component.scss']
})
export class LatestReleaseNoteDialogComponent {
    #releaseNotesService = inject(ReleaseNotesService)

    @Input() releaseNote!: ReleaseNote

    constructor(private activeModal: NgbActiveModal) {}

    public ackowledge() {
        this.#releaseNotesService.ackowledgeReleaseNote(this.releaseNote.id).subscribe(() => this.activeModal.close(true))
    }

    public dismiss() {
        this.activeModal.dismiss()
    }
}
